import _ from 'lodash';
import {calculateGFDI} from '../reducers/point_data_grass';
import {calculateFFDI} from '../reducers/point_data_mcarthur_mk5';
import {formatAsDate} from './time_utils';

// Takes a full table of weather data and adds the Max FDI columns for both Forest and Grass for both Day 1 and Day 2.
export const addMaxFdiValues = (dataMap, wind_reduction_factor) => {
  const max_ffdi_map = {};
  const max_gfdi_map = {};

  _.forOwn(dataMap, (values) => {
    if (values.time) {
      const date = formatAsDate(values.time);

      // While there is no extrenal source of FDI (BOM no longer calculating and Weather Data Lake not ready), we
      // calculate it here.
      const ffdi = calculateFFDI(values, wind_reduction_factor);
      const gfdi = calculateGFDI(values);
      values['FFDI'] = ffdi;
      values['GFDI'] = gfdi;

      _addToMaxMap(max_ffdi_map, date, ffdi);
      _addToMaxMap(max_gfdi_map, date, gfdi);
    }
  });

  const dates = _.keys(max_ffdi_map).sort();

  _.forOwn(dataMap, (values) => {
    if (values.time) {
      const dateDay1 = formatAsDate(values.time);
      const dateDay2 = dates[dates.indexOf(dateDay1) + 1];

      values.MAX_FFDI_DAY1 = max_ffdi_map[dateDay1];
      values.MAX_FFDI_DAY2 = max_ffdi_map[dateDay2];
      values.MAX_GFDI_DAY1 = max_gfdi_map[dateDay1];
      values.MAX_GFDI_DAY2 = max_gfdi_map[dateDay2];
    }
  });
};

function _addToMaxMap(map, date, value) {
  if (typeof map[date] === 'undefined' || map[date] < value) {
    map[date] = value;
  }
}



// WEBPACK FOOTER //
// ./src/utils/fdi_utils.js